// Stylesheet injected ONLY into the hidden print iframe (see Breadcrumb.vue),
// so it never affects the on-screen app or other pages.
export default `
<style id="pro-print-style">
  @page { size: A4 landscape; margin: 9mm 8mm 12mm; }
  * { box-sizing: border-box; }
  html, body {
    background: #fff !important; color: #1f2d3d !important; direction: rtl !important;
    font-family: "Neo Sans Arabic", Tahoma, Arial, sans-serif !important;
    -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important;
  }
  body { margin: 0 !important; padding: 0 !important; }
  .table-print { display: block !important; width: 100% !important; }
  .main-table { border: 0 !important; margin: 0 0 14px !important; box-shadow: none !important; }

  /* ---------- Report header ---------- */
  .print-header {
    display: block !important; margin: 0 0 14px !important; padding: 0 !important;
    border-radius: 8px; overflow: hidden; border: 1px solid #14304f;
    text-align: right !important;
  }
  .print-header::before {
    content: "Golden Eyes"; display: block; direction: ltr; text-align: center;
    background: #0e2338; color: #e8c777; letter-spacing: 3px; font-size: 11px;
    font-weight: bold; padding: 5px 0;
  }
  .print-header h3 {
    margin: 0 !important; padding: 12px 18px !important; text-align: center !important;
    font-size: 20px !important; font-weight: bold !important; color: #fff !important;
    background: linear-gradient(90deg, #14304f, #1f5f99, #14304f) !important;
  }
  .print-header .head {
    display: flex !important; justify-content: space-between !important; align-items: center !important;
    margin: 0 !important; padding: 7px 18px !important; border: 0 !important;
    background: #eaf1f8 !important; border-top: 1px solid #c9d3df !important;
    order: 3;
  }
  .print-header .head h1, .print-header .head h2 {
    margin: 0 !important; font-size: 11px !important; font-weight: normal !important; color: #3d5368 !important;
  }

  /* ---------- Table ---------- */
  .v-data-table { direction: rtl !important; background: #fff !important; border: 0 !important; border-radius: 0 !important; }
  .v-data-table__wrapper { overflow: visible !important; border: 0 !important; }
  .v-data-table > .v-data-table__wrapper > table {
    width: 100% !important; border-collapse: collapse !important; border: 1px solid #b9c6d4 !important;
    table-layout: auto !important;
  }
  thead { display: table-header-group !important; }
  tfoot { display: table-footer-group !important; }
  .v-data-table thead tr { background: #1f5f99 !important; }
  .v-data-table thead th {
    background: #1f5f99 !important; color: #fff !important; font-size: 11.5px !important; font-weight: bold !important;
    text-align: center !important; vertical-align: middle !important; padding: 8px 5px !important;
    line-height: 1.4 !important; height: auto !important; min-width: 0 !important; width: auto !important;
    border: 1px solid #14304f !important; white-space: normal !important;
  }
  .v-data-table thead th i, .v-data-table thead th .v-icon { display: none !important; }
  .v-data-table tbody tr {
    page-break-inside: avoid !important; break-inside: avoid !important; width: auto !important;
    background: #fff !important;
  }
  .v-data-table tbody tr:nth-child(even) { background: #f1f6fb !important; }
  .v-data-table tbody td {
    font-size: 11px !important; line-height: 1.55 !important; padding: 6px 6px !important;
    text-align: center !important; vertical-align: middle !important; height: auto !important;
    width: auto !important; white-space: normal !important; word-break: break-word; overflow-wrap: anywhere;
    border: 1px solid #d3dce6 !important; color: #22313f !important;
  }
  /* index column */
  .v-data-table tbody td:first-child { font-weight: bold !important; color: #1f5f99 !important; width: 28px !important; }
  /* long text (description) column: last column, wider and readable */
  .v-data-table tbody td:last-child { text-align: right !important; min-width: 130px; max-width: 260px; font-size: 10.5px !important; }
  .v-data-table thead th:last-child { min-width: 130px !important; }

  .greenColor { color: #1b7f3b !important; font-weight: bold !important; }
  .redColor { color: #c62828 !important; font-weight: bold !important; }
  a, span { text-decoration: none !important; }

  /* ---------- Totals ---------- */
  .showMoney { border: 0 !important; margin-top: 12px !important; page-break-inside: avoid !important; break-inside: avoid !important; }
  .showMoney ul { list-style: none !important; margin: 0 0 8px !important; padding: 0 !important; border: 0 !important; display: flex !important; gap: 8px; }
  .showMoney ul li {
    flex: 1 1 0 !important; width: auto !important; padding: 10px 14px !important; margin: 0 !important;
    border: 1px solid #c9d3df !important; border-radius: 8px !important; background: #f6f9fc !important;
    font-size: 13px !important; font-weight: bold !important;
  }
  .showMoney ul li:first-of-type { border-right: 5px solid #1b7f3b !important; }
  .showMoney ul li:nth-of-type(2) { border-right: 5px solid #c62828 !important; }
  .showMoney ul.last_ul li {
    background: #14304f !important; border: 1px solid #14304f !important; border-right: 5px solid #e8c777 !important;
    color: #fff !important; font-size: 14px !important;
  }
  .showMoney ul.last_ul li * { color: #fff !important; }
  .showMoney .state-count { display: block !important; }
  .showMoney .state-count > span:first-child { color: #5b6f84; font-weight: normal; margin-left: 6px; }
  .showMoney ul.last_ul .state-count > span:first-child { color: #e8c777 !important; }
  .all-state-count { width: auto !important; }
</style>
`;
